import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import PrivilegedContent from '@components/PrivilegedContent/PrivilegedContent'
import dashboardContainer from './DashboardContainer'
import candidateStatuses from '@server/constants/statuses/candidate-statuses'

import candidateIcon from './icons/icon-candidate.png'
import clientIcon from './icons/icon-client.png'
import jobIcon from './icons/icon-job.png'
import timesheetIcon from './icons/icon-timesheet.png'

import './Dashboard.scss'

const NotifyLink = ({ to, count, message }) => {
	if(isNaN(count) || count === 0) return '';
	const _message = typeof message === 'function' ? message(count) : message;
	return <Link className="NotifyLink" to={to}>{_message}</Link>
}

const IconLink = ({ to, count, label, icon }) => {
	count = count && count > 0 ? count : false
	return (
		<Link to={to} className="IconLink">
			<div className="IconLink-iconWrap" style={{backgroundImage: `url(${icon})`}}>
				{
					count
					&& <span className="IconLink-count">{count}</span>
				}
			</div>
			{label}
		</Link>
	)
}


const PrivilegedIconLink = ({ permissions, ...props}) => 
	(<PrivilegedContent permissions={permissions} >
		<IconLink {...props} />
	</PrivilegedContent>)

class Dashboard extends Component {

	get notifyLinksConfig() {
		return [
			{
				key: 'candidate',
				message: count => `You have ${count} new candidate${count > 1 ? 's' : ''} to review`,
				to: `/candidates?status=${candidateStatuses.find(s => s.key === 'unverified').order}`
			},
			{
				key: 'job',
				message: count => `You have ${count} job${count > 1 ? 's' : ''} to review`,
				to: "/jobs"
			},
			{
				key: 'timesheet',
				message: count => `You have ${count} timesheet${count > 1 ? 's' : ''} to review`,
				to: "/timesheets"
			},
		];
	}

  render() {
		const { account: { data } } = this.props;
		const firstName = data && data.name && data.name.first;
		// const validationSchema = ;
		// console.log(validationSchema)
    return (
      <main className="Dashboard page-content">
      	<header>
      		<h1>Dashboard</h1>
      		<p>Welcome{firstName ? `  ${firstName}` : ''},</p>
      	</header>

      	{this.renderNotifyLinks()}

      	{this.renderIconLinks()}

      </main>
    )
  }

  renderNotifyLinks() {
		const { countData } = this.props.counts;
		return this.notifyLinksConfig.map(({key, ...props}) =>
			<NotifyLink
				key={key}
				count={countData[key]}
				{...props}
			/>
		)
	}

	renderIconLinks() {
		const { countData } = this.props.counts;
		return (
			<div className="IconLinks">
				<PrivilegedIconLink 
					to="/candidates" 
					label="Candidates" 
					count={countData['candidate']} 
					permissions={['readOwn:candidate']}
					icon={candidateIcon}
				/>
				<PrivilegedIconLink 
					to="/jobs" 
					label="Job Board" 
					count={countData['job']}
					permissions={['readOwn:job']}
					icon={jobIcon}
				/>
				<PrivilegedIconLink 
					to="/timesheets" 
					label="Timesheets" 
					count={countData['timesheet']} 
					permissions={['readOwn:timesheet']}
					icon={timesheetIcon}
				/>
				<PrivilegedIconLink 
					to="/clients" 
					label="Clients" 
					permissions={['readOwn:client']}
					icon={clientIcon}
				/>
			</div>
		)
	}
}

export default dashboardContainer(Dashboard);



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/Dashboard.jsx